import { initialFleetVehicleExpenseEditForm } from "services/api/fleet/vehicles/expenses/consts";
import { FleetVehicleExpenseEditFormValues } from "services/api/fleet/vehicles/expenses/types";

/** Novi trošak kreće bez vozila — dok se ne odabere, riječ je o trošku tvrtke. */
export const INITIAL_EXPENSE_FORM: FleetVehicleExpenseEditFormValues = {
  ...initialFleetVehicleExpenseEditForm,
  vehicleId: null,
  expenseTypeId: null,
};
